import { toast } from 'react-toastify';
import { authAxiosInstance } from '../../utils/axiosConfig';
import QueryString from 'qs';
import { showError } from '../../utils/Utils';

export const createCuttingCard = async (data) => {
    try {
        const createResp = await authAxiosInstance.post('/cuttingCard', data);
        return createResp;
    } catch (error) {
        console.log(error);
        toast.error('failed to create cutting card');
    }
};

export const fetchCuttingCards = async (data) => {
    try {
        console.log('fetching cutting cards');
        const string = QueryString.stringify(data);
        const receiveResp = await authAxiosInstance.get(
            `/cuttingCard?${string}`
        );
        return receiveResp.data;
    } catch (error) {
        console.log(error);
        toast.error('failed to fetch Cutting Cards');
    }
};

export const receiveCuttingCard = async (data) => {
    try {
        console.log('receiveCuttin', data);
        const receiveResp = await authAxiosInstance.post(
            '/cuttingCard/receive',
            data
        );
        return receiveResp.data;
    } catch (error) {
        console.log(error);
        toast.error('failed to receive cutting card');
    }
};

export const deleteCuttingCard = async (id) => {
    try {
        const deleteResp = await authAxiosInstance.delete(`/cuttingCard/${id}`);
        return deleteResp.data;
    } catch (error) {
        console.log(error);
        showError(error);
    }
};
